module.exports = __webpack_public_path__ + "img/js.0a6c74aa.svg";